module.exports = __webpack_public_path__ + "img/has-coupon-icon@3x.b6d286c1.png";